angular.module('pb.core.auth', []);
